import { createContext, type ReactNode, useContext } from 'react';
import { DEFAULT_LOCALE, isValidLocale, type Locale } from './constants.js';
import { getFullDictionary } from './getDictionary.js';
import type { Dictionary } from './types.js';

interface LocaleContextValue {
    locale: Locale;
    dictionary: Dictionary;
}

const LocaleContext = createContext<LocaleContextValue | null>(null);

export function useLocaleContext(): LocaleContextValue {
    const context = useContext(LocaleContext);

    if (!context) {
        throw new Error('useLocaleContext must be used within a LocaleProvider');
    }

    return context;
}

export function LocaleProvider({ locale, children }: { locale: string; children: ReactNode }) {
    const resolvedLocale = isValidLocale(locale) ? locale : DEFAULT_LOCALE;
    const dictionary = getFullDictionary(resolvedLocale);

    return (
        <LocaleContext.Provider value={{ locale: resolvedLocale, dictionary }}>
            {children}
        </LocaleContext.Provider>
    );
}
